import React, { useEffect } from "react"
import { Column } from "@fiken/components"
import Styles from "./Filter.module.css"
import OrgVelger from "./OrgVelger"
import MvaRegistrertLenke from "./MvaRegistrertLenke"
import { BaseViewProp } from "../../types/type"
import { useParams } from "react-router-dom"
import { storeParams } from "../konto/paramsStorage"

type FilterProps = BaseViewProp

export default function Filter({ children }: FilterProps): React.ReactElement {
  const params = useParams()
  useEffect(() => {
    storeParams(params)
  }, [params])

  return (
    <section>
      <Column className={Styles.filter}>
        <OrgVelger />
        <MvaRegistrertLenke />
      </Column>
      <Column className={Styles.search}>{children}</Column>
    </section>
  )
}
